import React from 'react';
import { FormattedMessage, type MessageDescriptor } from 'react-intl';

import { Stack, Text } from '@mantine/core';

type ReturnsPanelHeaderProps = {
  titleMessage: MessageDescriptor;
  descriptionMessage: MessageDescriptor;
};

export const ReturnsPanelHeader = ({ titleMessage, descriptionMessage }: ReturnsPanelHeaderProps) => {
  return (
    <Stack gap={0}>
      <Text size='sm'>
        <FormattedMessage {...titleMessage} />
      </Text>
      <Text c='gray' size='xs'>
        <FormattedMessage {...descriptionMessage} />
      </Text>
    </Stack>
  );
};
